import React, { useMemo, useCallback } from 'react';
import Badge from '@mui/material/Badge';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { validatePermissions } from 'FielderUtils/validatePermissions';
import { useLanguage } from 'Context/LanguageContext';
import { FielderSmartNav } from '~/FielderElements/Utils/SmartTabNav';

const SELECTION_TASK = 1;
const SELECTION_ROUTE = 2;
const SELECTION_TASKGROUP = 3;
const SELECTION_AUTOASSIGN = 4;
const MyOperationNavigationBar = (
  {
    canViewTasks,
    options,
    showSearchByForms,
    validateTabView,
    notificationCount,
    notificationCountGroup,
    showRouteOpt,
    canViewRoutes,
    changeLoadingFilter,
    resetTaskSection,
    resetRouteSection,
    resetGroupTaskSection,
    resetAutoAssignSection,
    state,
    groupTaskFunctionality,
    canViewTaskGroups,
    autoassign,
    selectedRows,
  }) => {
  const lan = useLanguage();
  const user = useSelector(selectUser);
  const items = useMemo(() => {
    const arr = [];

    if (canViewTasks) {
      arr.push({
        id: SELECTION_TASK,
        label: <Box component="span">{lan.tasks}</Box>,
      });
    }

    if (showRouteOpt && validatePermissions(user, state, 'route') && canViewRoutes) {
      arr.push({
        id: SELECTION_ROUTE,
        label: <Box component="span">{lan.routes}</Box>,
      });
    }

    if (!RoleUtils.isUserClient(user) && groupTaskFunctionality && canViewTaskGroups) {
      arr.push({
        id: SELECTION_TASKGROUP,
        label: (
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
            {lan.taskGroupUpperCase}
            {notificationCountGroup > 0 && (
              <Badge
                badgeContent={notificationCountGroup}
                className="Fielder-icon-button"
                sx={{
                  '& .MuiBadge-badge': {
                    minWidth: 20, height: 20, fontSize: '0.75rem', backgroundColor: '#dc5c87',
                    color: 'white', top: '-7px', right: '-16px', borderRadius: '50%',
                    fontWeight: 'bold', boxShadow: '0 0 0 1px white',
                  },
                }}
              />
            )}
          </Box>
        ),
      });
    }

    if (autoassign?.hasFunctionality && !RoleUtils.isUserClient(user)) {
      arr.push({
        id: SELECTION_AUTOASSIGN,
        label: <Box component="span">{lan.autoassignation}</Box>,
      });
    }

    return arr;
  }, [
    canViewTasks, showRouteOpt, canViewRoutes, user, state,
    groupTaskFunctionality, canViewTaskGroups, autoassign?.hasFunctionality,
    lan, notificationCountGroup,
  ]);
  const handleChange = useCallback((id) => {
    switch (id) {
      case SELECTION_TASK:
        validateTabView(SELECTION_TASK);
        resetTaskSection();
        if (showSearchByForms) changeLoadingFilter(true);
        break;

      case SELECTION_ROUTE:
        validateTabView(SELECTION_ROUTE);
        resetRouteSection();
        break;

      case SELECTION_TASKGROUP:
        if (Array.isArray(selectedRows)) selectedRows.length = 0;
        validateTabView(SELECTION_TASKGROUP);
        resetGroupTaskSection();
        break;

      case SELECTION_AUTOASSIGN:
        validateTabView(SELECTION_AUTOASSIGN);
        resetAutoAssignSection();
        break;

      default:
        break;
    }
  }, [
    changeLoadingFilter,
    resetTaskSection,
    resetRouteSection,
    resetGroupTaskSection,
    resetAutoAssignSection,
    selectedRows,
    showSearchByForms,
    validateTabView,
  ]);

  return (
    <Box sx={{ width: '94%', zIndex: 999}}
    >
      <FielderSmartNav
        items={items}
        value={options}
        onChange={handleChange}
        centered={false}
        variant="fullWidth"
        sx={{
          '& .MuiTab-root': { textAlign: 'center' },
        }}
      />
    </Box>
  );
};

export default React.memo(MyOperationNavigationBar);
//Original code:
